import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils'

type ListProp = {
  extraReward: number
  userCnt: number
  isFinished: boolean
}

type InviteProps = {
  invitationCode: string
  redemptionStatus: number
  userStatus: number
  invitationTokenCnt: number
  list: ListProp[]
}

type InitialProp = {
  inviteData: InviteProps
  character: any[]
}

const initialState = {
  inviteData: {
    invitationCode: null,
    redemptionStatus: null,
    userStatus: null,
    invitationTokenCnt: null,
    list: null,
  },
  character: null,
} as InitialProp

export const inviteInfo = createAsyncThunk<any, any>(
  'inviteInfo',
  async (arg, store) => {
    return req(
      '/task/get_invitation_info',
      // @ts-ignore
      {...arg},
      store,
      false,
      null
    )
  }
)

export const redeemInvitationReward = createAsyncThunk<any, any>(
  'redeemInvitationReward',
  async (arg, store) => {
    return req(
      '/task/redeem_invitation_reward',
      // @ts-ignore
      {...arg},
      store,
      false,
      null
    )
  }
)

export const discoverList = createAsyncThunk<any, any>(
  'discoverList',
  async (arg, store) => {
    return req(
      '/character/get_discover_list_h5',
      // @ts-ignore
      {...arg},
      store,
      false,
      null
    )
  }
)

export const reportSlice = createSlice({
  name: 'invite',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(inviteInfo.fulfilled, (state, action) => {
      return {
        ...state,
        inviteData: action.payload,
      }
    })
    builder.addCase(discoverList.fulfilled, (state, action) => {
      return {
        ...state,
        character: action.payload.character,
      }
    })
  },
})

export default reportSlice.reducer
